import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  CircularProgress,
  Typography,
} from "@mui/material";
import moment from "moment";
import { fetchTeacherTimetable } from "../../TimeTable/redux/myTimetableSlice";
import { fetchSessionsThunk } from "../../../AcademicCalendar/redux/academicCalendarSlice";
import { getSyllabusThunk } from "../../redux/syllabusthunk";
import { generateLessonPlan } from "../HomeWorks/generateLessonPlan";
import { fetchTeacherProjects } from "../../Projects/redux/projectThunk";
import { resetData } from "../../Projects/redux/projectSlice";
import userStore from "../../../../zustand/userStore";
import Popup from "../../../EventOrganiser/Popup";
import { setStepIndex, setStepValid, stopTour , startTour} from "../../../../redux/globalJoyrideSlice";
import { myProjectsTourSteps } from "../../../../tour/teacherPlanerTourSteps";

const MyProjects = ({ teacherId }) => {
  const dispatch = useDispatch();
  const {
    teacherProjects: projects,
    loading,
    error,
  } = useSelector((state) => state.project);
  const { syllabusData } = useSelector((state) => state.syllabus);
  const { teacherPeriods } = useSelector((state) => state.myTimetable);
  const { sessions } = useSelector((state) => state.academicCalendar);

  const [weeklyPlan, setWeeklyPlan] = useState([]);
  const [formData, setFormData] = useState({
    selectedClass: "",
    selectedSection: "",
  });

  const userData = userStore((state) => state.user);
  const teacher_id = userData?.teacher_id;
const { stepIndex, run } = useSelector(
  (state) => state.globalJoyride
);
const navigate=useNavigate();
  useEffect(() => {
    if (teacher_id) {
      dispatch(fetchTeacherProjects({ teacher_id: teacher_id, school_id: 1 }));
      dispatch(fetchTeacherTimetable(teacher_id));
      dispatch(fetchSessionsThunk());
      dispatch(getSyllabusThunk(teacher_id));
      return function () {
        dispatch(resetData());
      };
    }
  }, [dispatch, teacher_id]);

  useEffect(() => {
    const LAST_STEP_INDEX = 4;
  
    if (run && stepIndex === LAST_STEP_INDEX) {
      // 1. Stop the tour FIRST
      dispatch(stopTour());
      
      // 2. Use a tiny timeout to let Joyride clean up its DOM references
      setTimeout(() => {
        navigate("/allHomeworks");
      }, 100); 
    }
  }, [stepIndex, run, dispatch, navigate]);
  useEffect(() => {
    if (teacherPeriods?.classes?.length > 0) {
      setTimeout(() => {
        dispatch(setStepIndex(1));
      }, 100);
    }
  }, [teacherPeriods.classes]);

  useEffect(() => {
    if (
      !syllabusData.length ||
      !teacherPeriods.classes?.length ||
      !sessions.length
    )
      return;

    const { weeks } = generateLessonPlan({
      syllabusData,
      sessions,
      teacherPeriods,
      selectedClass: "",
      selectedSubject: "",
      selectedSection: "",
    });

    setWeeklyPlan(weeks);
  }, [syllabusData, teacherPeriods, sessions]);

  if (!userData?.teacher_id) {
    return (
      <Popup
        title="Access Restricted"
        height="300px"
        maxWidth="500px"
        onClose={() => window.history.back()}
        minHeight="200px"
      >
        <div className="text-center p-4">
          <h3 className="text-xl font-bold mb-3">
            ⚠️ Teacher Assignment Needed
          </h3>
          <p className="mb-4">
            You are not yet assigned as a teacher. Please contact the
            administrator to get a teacher ID before viewing your timetable.
          </p>
          <button
            className="btn btn-primary"
            onClick={() => window.history.back()}
          >
            Go Back
          </button>
        </div>
      </Popup>
    );
  }

  const handleChange = (e) => {
    setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const findProject = (row) => {
    const chapterRows = weeklyPlan
      .flat()
      .filter(
        (r) =>
          String(r.class_id) === String(row.class_id) &&
          String(r.period?.section_id) === String(row.period?.section_id) &&
          String(r.period?.subject_id) === String(row.period?.subject_id) &&
          r.chapter.trim().toLowerCase() === row.chapter.trim().toLowerCase()
      );

    const proj = projects.find(
      (p) =>
        String(p.class_id) === String(row.class_id) &&
        String(p.section_id) === String(row.period?.section_id) &&
        String(p.subject_id) === String(row.period?.subject_id) &&
        p.chapter_name.trim().toLowerCase() ===
          row.chapter.trim().toLowerCase() &&
        String(p.period_number) === String(row.sno)
    );

    if (!proj) return null;

    const matchedRow = chapterRows.find(
      (r) => String(r.sno) === String(proj.period_number)
    );

    return matchedRow ? { ...proj, date: matchedRow.period.date } : null;
  };

  const allRows = weeklyPlan.flat();

  const filteredRows = allRows
    .map((row) => {
      const proj = findProject(row);
      return proj ? { row, proj } : null;
    })
    .filter(Boolean)
    .filter(({ proj }) => {
      if (formData.selectedClass && proj.class_id !== formData.selectedClass)
        return false;
      if (
        formData.selectedSection &&
        proj.section_id !== formData.selectedSection
      )
        return false;
      return true;
    });
  return (
    <div style={{ maxWidth: 1300, margin: "auto", marginTop: 0 }}>
      <div style={{ display: "flex", gap: "20px", marginBottom: "20px" }}>
        <div>
          <label>Select Class</label>
          <select
           data-tour="projects-select-class"
            name="selectedClass"
            value={formData.selectedClass}
            onChange={(e)=>{
              handleChange(e);
              dispatch(setStepIndex(2))
            }}
            style={{ padding: "5px", marginLeft: "10px" }}
          >
            <option value="">-- Select Class --</option>
            {teacherPeriods?.classes?.map((cls) => (
              <option key={cls.class_id} value={cls.class_id}>
                {cls.class_name}
              </option>
            ))}
          </select>
        </div>

        <div>
          <label>Select Section</label>
          <select
          data-tour="projects-select-section"
            name="selectedSection"
            value={formData.selectedSection}
            onChange={(e)=>{
              handleChange(e);
              dispatch(setStepIndex(3))
            }}

            style={{ padding: "5px", marginLeft: "10px" }}
          >
            <option value="">-- Select Section --</option>
            {teacherPeriods?.classes
              ?.find((cls) => cls.class_id == formData.selectedClass)
              ?.sections?.map((sec) => (
                <option key={sec.section_id} value={sec.section_id}>
                  {sec.section_name}
                </option>
              ))}
          </select>
        </div>
      </div>

      <TableContainer
      data-tour="projects-table"
       component={Paper} sx={{ width: "100%", boxShadow: 3 }}>
        {loading && <CircularProgress sx={{ m: 2 }} />}
        {error && <Typography color="error">{error}</Typography>}

        {!loading && !error && (
          <Table size="small">
            <TableHead>
              <TableRow sx={{ backgroundColor: "#f0f0f0" }}>
                <TableCell>Date</TableCell>
                <TableCell>Day</TableCell>
                <TableCell>Class</TableCell>
                <TableCell>Section</TableCell>
                <TableCell>Subject</TableCell>
                <TableCell>Chapter</TableCell>
                <TableCell>Period</TableCell>
                <TableCell>Project Details</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {filteredRows.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={8} align="center">
                    No Data Found
                  </TableCell>
                </TableRow>
              ) : (
                filteredRows.map(({ row, proj }, index) => (
                  <TableRow key={index}>
                    <TableCell>
                      {moment(proj.date).format("DD-MM-YYYY")}
                    </TableCell>
                    <TableCell>{moment(proj.date).format("dddd")}</TableCell>
                    <TableCell>{proj.class_name}</TableCell>
                    <TableCell>{proj.section_name}</TableCell>
                    <TableCell>{proj.subject_name}</TableCell>
                    <TableCell>{proj.chapter_name}</TableCell>
                    <TableCell>{proj.period_number}</TableCell>
                    <TableCell>
                      <ProjectDetailsCell proj={proj} row={row} />
                    </TableCell>
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        )}
      </TableContainer>
    </div>
  );
};

const ProjectDetailsCell = ({ proj, row }) => {
  const [expandedItems, setExpandedItems] = useState({});
  const toggleExpand = (key) =>
    setExpandedItems((prev) => ({ ...prev, [key]: !prev[key] }));

  try {
    const details = JSON.parse(proj.project_details);

    // ✅ Group by eventName
    let grouped = {};
    if (proj.is_old === "1" && Array.isArray(details)) {
      details.forEach((item) => {
        if (!grouped[item.eventName]) grouped[item.eventName] = [];
        grouped[item.eventName].push(item.projectName);
      });
    }

    // ✅ Prepare text for view-more check
    let fullText = "";
    if (proj.is_old === "2") {
      fullText = `Name: ${details.name}\nDescription: ${details.subject}`;
    } else if (proj.is_old === "1") {
      fullText = Object.entries(grouped)
        .map(([event, projects]) => `${event} -> ${projects.join(", ")}`)
        .join("\n");
    }

    const key = `proj-${proj.id}-${row.sno}`;
    const isExpanded = expandedItems[key] || false;

    return (
      <div style={{ fontSize: "14px" }}>
        {fullText.length <= 30 || isExpanded ? (
          <>
            {proj.is_old === "2" ? (
              <>
                <div>
                  <b>Name:</b> {details.name}
                </div>
                <div>
                  <b>Description:</b> {details.subject}
                </div>
              </>
            ) : (
              Object.entries(grouped).map(([event, projects], i) => (
                <div key={i} style={{ marginBottom: "6px" }}>
                  <div style={{ fontWeight: "bold" }}>📌 {event}</div>
                  <ul style={{ marginLeft: "20px", paddingLeft: "10px" }}>
                    {projects.map((p, idx) => (
                      <li key={idx}>{p}</li>
                    ))}
                  </ul>
                </div>
              ))
            )}
          </>
        ) : (
          fullText.slice(0, 30) + "..."
        )}

        {fullText.length > 30 && (
          <span
            style={{ color: "blue", cursor: "pointer", marginLeft: "5px" }}
            onClick={() => toggleExpand(key)}
          >
            {isExpanded ? "View Less" : "View More"}
          </span>
        )}
      </div>
    );
  } catch (err) {
    return <i>Invalid Data</i>;
  }
};

export default MyProjects;
